import { ref, onMounted } from 'vue'

export function useDevice() {
  const isMobile = ref(false)
  const isTablet = ref(false)
  const isDesktop = ref(false)
  const deviceType = ref<'mobile' | 'desktop'>('desktop')
  const isLandscape = ref(false)

  const detect = () => {
    const ua = navigator.userAgent
    isMobile.value = /iPhone|iPod|Android(?!.*Tablet)/i.test(ua)
    isTablet.value = /iPad|Android.*Tablet|Tablet/i.test(ua)
    isDesktop.value = !isMobile.value && !isTablet.value
    deviceType.value = isMobile.value || isTablet.value ? 'mobile' : 'desktop'
    isLandscape.value = window.innerWidth > window.innerHeight
  }

  const handleResize = () => {
    isLandscape.value = window.innerWidth > window.innerHeight
  }

  onMounted(() => {
    detect()
    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)
  })

  return {
    isMobile,
    isTablet,
    isDesktop,
    deviceType,
    isLandscape
  }
}
